"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.extractSearchAirlineCodes = extractSearchAirlineCodes;
exports.extractSearchAirportCodes = extractSearchAirportCodes;
exports.formatSearchResults = formatSearchResults;
exports.getDomesticPriceDetails = getDomesticPriceDetails;
exports.getDomesticTotalPrice = getDomesticTotalPrice;
exports.getDomesticTotalPriceDetails = getDomesticTotalPriceDetails;
exports.getFirstNearbyIndex = getFirstNearbyIndex;
exports.getFirstNearbyItineraryId = getFirstNearbyItineraryId;
exports.getNumberOfDifferentBaggageOption = getNumberOfDifferentBaggageOption;
exports.getNumberOfFlightsByAirlineCode = getNumberOfFlightsByAirlineCode;
exports.getNumberOfFlightsWithOptionByAirlineCode = getNumberOfFlightsWithOptionByAirlineCode;
exports.getTopPickCombinedItineraries = getTopPickCombinedItineraries;
exports.mergeSearchResultsChunks = mergeSearchResultsChunks;
exports.updateSearchResultsChunks = updateSearchResultsChunks;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _compact2 = _interopRequireDefault(require("lodash/compact"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _lowerCase2 = _interopRequireDefault(require("lodash/lowerCase"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _segment = require("./segment.utils");
var _leg = require("./leg.utils");
var _itinerary = require("./itinerary.utils");
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function formatSearchResults(_ref) {
  var searchResults = _ref.searchResults,
    searchRequest = _ref.searchRequest,
    $currency = _ref.$currency,
    config = _ref.config;
  var segment = searchResults.segment,
    leg = searchResults.leg,
    itineraries = searchResults.itinerary,
    vendor = searchResults.vendor;
  var segmentHashMap = (0, _segment.generateSegmentHashMap)({
    segments: segment,
    searchRequest: searchRequest
  });
  var legHashMap = (0, _leg.generateLegHashMap)({
    legs: leg,
    segmentHashMap: segmentHashMap,
    searchRequest: searchRequest
  });
  var itineraryHashMap = (0, _itinerary.generateItineraryHashMap)({
    itineraries: itineraries,
    legHashMap: legHashMap,
    searchRequest: searchRequest,
    vendor: vendor,
    $currency: $currency,
    config: config
  });
  return {
    segmentHashMap: segmentHashMap,
    legHashMap: legHashMap,
    itineraryHashMap: itineraryHashMap
  };
}
function mergeSearchResultsChunks(searchResultsChunks) {
  var mergedSearchResults = {
    itinerary: [],
    leg: [],
    segment: [],
    vendor: ''
  };
  (0, _each2.default)(searchResultsChunks, function (_ref2) {
    var res = _ref2.res;
    (0, _each2.default)(res, function (chunk) {
      var status = (0, _get2.default)(chunk, 'status');
      var data = (0, _get2.default)(chunk, 'data');
      if (status === 200) {
        mergedSearchResults.itinerary = mergedSearchResults.itinerary.concat((0, _get2.default)(data, 'itinerary', []));
        mergedSearchResults.leg = mergedSearchResults.leg.concat((0, _get2.default)(data, 'leg', []));
        mergedSearchResults.segment = mergedSearchResults.segment.concat((0, _get2.default)(data, 'segment', []));
        mergedSearchResults.vendor = (0, _get2.default)(data, 'provider', '');
      }
    });
  });
  return mergedSearchResults;
}
function updateSearchResultsChunks(searchResultsChunks, responseData) {
  var existingCidMap = new Map(searchResultsChunks.flatMap(function (chunk) {
    return chunk.res.map(function (res) {
      return [res.cid, chunk];
    });
  }));
  var newResponses = [];
  responseData.res.forEach(function (newRes) {
    var existingChunk = existingCidMap.get(newRes.cid);
    if (existingChunk) {
      var index = existingChunk.res.findIndex(function (res) {
        return res.cid === newRes.cid;
      });
      if (index !== -1) {
        existingChunk.res[index] = newRes;
      }
    } else {
      newResponses.push(newRes);
    }
  });
  return newResponses;
}
function extractSearchAirportCodes(_ref3) {
  var segments = _ref3.segments,
    requestAirports = _ref3.searchRequest.requestAirports;
  var airports = (0, _flatMap2.default)(requestAirports);
  (0, _each2.default)(segments, function (segment) {
    airports.push(segment.departureCode);
    airports.push(segment.arrivalCode);
    (0, _each2.default)(segment.technicalStops, function (_ref4) {
      var airport = _ref4.airport;
      airports.push(airport);
    });
  });
  return (0, _uniq2.default)((0, _compact2.default)(airports));
}
function extractSearchAirlineCodes(segments) {
  var airlines = [];
  (0, _each2.default)(segments, function (segment) {
    airlines.push(segment.operatingCarrierId);
    airlines.push(segment.marketingCarrierId);
  });
  return (0, _uniq2.default)((0, _compact2.default)(airlines));
}
function getFirstNearbyIndex(groupedResults) {
  return (0, _findIndex2.default)(groupedResults, function (groupedResult) {
    return (0, _get2.default)(groupedResult, '0.hasNearbyOrigin') || (0, _get2.default)(groupedResult, '0.hasNearbyDestination');
  });
}
function getDomesticPriceDetails(outboundItinerary, inboundItinerary) {
  var _outboundItinerary$di, _inboundItinerary$dis;
  var origin = (0, _get2.default)(outboundItinerary, 'legs[0].originId', '');
  var destination = (0, _get2.default)(outboundItinerary, 'legs[0].destinationId', '');
  var outboundPrice = (_outboundItinerary$di = outboundItinerary === null || outboundItinerary === void 0 ? void 0 : outboundItinerary.displayPrice) !== null && _outboundItinerary$di !== void 0 ? _outboundItinerary$di : {};
  var outbound = _objectSpread(_objectSpread({}, outboundPrice), {}, {
    origin: origin,
    destination: destination
  });
  var inboundPrice = (_inboundItinerary$dis = inboundItinerary === null || inboundItinerary === void 0 ? void 0 : inboundItinerary.displayPrice) !== null && _inboundItinerary$dis !== void 0 ? _inboundItinerary$dis : {};
  var inbound = _objectSpread(_objectSpread({}, inboundPrice), {}, {
    origin: destination,
    destination: origin
  });
  return {
    outbound: outbound,
    inbound: inbound
  };
}
function getDomesticTotalPriceDetails(outboundItinerary, inboundItinerary, $currency) {
  var outboundPrice = (0, _get2.default)(outboundItinerary, 'price', {});
  var inboundPrice = (0, _get2.default)(inboundItinerary, 'price', {});
  var combinedPrice = (0, _mapValues2.default)(outboundPrice, function (value, key) {
    if (key === 'hasDiscount') {
      return (0, _get2.default)(inboundPrice, 'hasDiscount', false) || (0, _get2.default)(outboundPrice, 'hasDiscount', false);
    }
    var combinedValue = (0, _get2.default)(outboundPrice, "" + key, 0) + (0, _get2.default)(inboundPrice, "" + key, 0);
    return $currency.formatPriceWithDecimals(combinedValue, 0);
  });
  return _objectSpread(_objectSpread({}, combinedPrice), {}, {
    currency: $currency.currentCurrency
  });
}
function getDomesticTotalPrice(outboundItinerary, inboundItinerary) {
  var outboundPrice = (0, _get2.default)(outboundItinerary, 'price', {});
  var inboundPrice = (0, _get2.default)(inboundItinerary, 'price', {});
  var combinedPrice = (0, _mapValues2.default)(outboundPrice, function (value, key) {
    if (key === 'hasDiscount') {
      return (0, _get2.default)(inboundPrice, 'hasDiscount', false) || (0, _get2.default)(outboundPrice, 'hasDiscount', false);
    }
    var combinedValue = (0, _get2.default)(outboundPrice, "" + key, 0) + (0, _get2.default)(inboundPrice, "" + key, 0);
    return combinedValue;
  });
  return combinedPrice;
}
function getNumberOfFlightsByAirlineCode(flights, airlineCode) {
  return (0, _filter2.default)(flights, function (flight) {
    return flight.validatingCarrier === airlineCode;
  }).length;
}
function getNumberOfFlightsWithOptionByAirlineCode(flights, airlineCode) {
  return (0, _filter2.default)(flights, function (flight) {
    return flight.validatingCarrier === airlineCode && _constants.VENDORS.TF_CODES.includes((0, _lowerCase2.default)(flight.vendor));
  }).length;
}
function getNumberOfDifferentBaggageOption(flights, airlineCode) {
  var totalFlightsNumber = flights.length;
  var totalFlightsNumberWithBaggageOption = getNumberOfFlightsWithOptionByAirlineCode(flights, airlineCode);
  var totalFlightsNumberWithBaggageIncluded = (0, _filter2.default)(flights, function (flight) {
    return flight.hasCheckInBaggage;
  }).length;
  var totalFlightsNumberWithoutBaggageIncluded = totalFlightsNumber - (totalFlightsNumberWithBaggageOption + totalFlightsNumberWithBaggageIncluded);
  return {
    totalFlightsNumberWithBaggageOption: totalFlightsNumberWithBaggageOption,
    totalFlightsNumberWithBaggageIncluded: totalFlightsNumberWithBaggageIncluded,
    totalFlightsNumberWithoutBaggageIncluded: totalFlightsNumberWithoutBaggageIncluded
  };
}
function getTopPickCombinedItineraries(groupedSearchResults, topPicksItineraries) {
  if (topPicksItineraries === void 0) {
    topPicksItineraries = [];
  }
  var firstOfGroupsResults = (0, _map2.default)(groupedSearchResults, '0');
  return [].concat(topPicksItineraries, firstOfGroupsResults);
}
function getFirstNearbyItineraryId(itineraries) {
  var firstItinerary = (0, _find2.default)(itineraries, function (_ref5) {
    var hasNearbyDestination = _ref5.hasNearbyDestination,
      hasNearbyOrigin = _ref5.hasNearbyOrigin;
    return hasNearbyDestination || hasNearbyOrigin;
  });
  return firstItinerary === null || firstItinerary === void 0 ? void 0 : firstItinerary.id;
}
var _default = exports.default = {
  formatSearchResults: formatSearchResults,
  mergeSearchResultsChunks: mergeSearchResultsChunks,
  extractSearchAirportCodes: extractSearchAirportCodes,
  extractSearchAirlineCodes: extractSearchAirlineCodes
};